export class ScheduleOrder {
    ldc: string = '';
    orderNumber: string = '';
    scheduleDate: string = '';
    scheduleWindow: string = '';
    fieldInstructions: string = '';
    premisesNumber: string = '';
    appointmentStart: string = '';
    appointmentEnd: string = '';
    personID: string = '';
    isKMIEligible: boolean = false;
    kmiTextOptIn: boolean = false;
    kmiPhoneNumber: string = '';
}

export class AGLCScheduleOrder {
    accountNumber: string = '';
    customerServiceRemarks: string = '';
    entranceCode: string = '';
    entranceInstructions: string = '';
    fieldInstructions: string = '';
    gateCode: string = '';
    intersectingStreet: string = '';
    isMeterNotAccessible: boolean = false;
    kmiCallbackOptIn: boolean = false;
    kmiTextOptIn: boolean = false;
    marketerReferenceID: string = '';
    premiseNumber: string = '';
    requestorName: string = '';
    requestorPhone: string = '';
    safetyQuestionAnswer1: string = '';
    safetyQuestionAnswer2: string = '';
    safetyQuestionAnswer3: string = '';
    safetyQuestionAnswer4: string = '';
    safetyQuestionAnswer5: string = '';
    safetyQuestionAnswer6: string = '';
    scheduleDate: string = '';
    scheduleTime: string = '';
    scheduleWindow: string = '';
    serviceOrderType: string = '';
    serviceOrderTypeDescription: string = '';
    serviceOrderTypeReason: string = '';
    serviceOrderTypeReasonID: number = 0;
    specialInstructions: string = '';
    subdivisionName: string = '';
}

export enum SchedulingElgibleOrders {
    Reconnect = "RECONNECT",
    ILS1 = "ILSLETTR1",
    ILS3 = "ILSLETTR3"
}

export enum SchedulingElgibleLDCs {
    NG = "NG",
    VNG = "VNG",
    CGC = "CGC",
    AGLC = "AGLC"
}

//export class AccountDetails {
//    isValidAccount: boolean = false;
//    isOrderEligibleToSchedule: boolean = false; 
//    orderNumber: string = ''; 
//    premiseNumber: string = '';
//    personID: string = '';
//    ldc: string = '';    
//    serviceCenter: string = '';
//    billingAddress: string = ''; 
//    premisesAddress: string = ''; 
//    customerName: string = ''; 
//    customerFirstName: string = '';
//    emailAddress: string = ''; 
//    phoneNumber: string = ''; 
//    premiseType: string = '';
//    isKMIEligible: boolean = false;
//    marketerName: string = '';
//    marketerPhoneNumber: string = '';
//}

//export class AppConfigurationData {
//    configurationKey: string = '';
//    configurationTitle: string = '';
//    configurationType: string = '';
//    configurationValue: string = '';
//    description: string = '';
//    ldc: string = '';
//}
